export default __webpack_public_path__ + "static/media/red-background.92a5bde7.png";